var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'v-info',
        ("v-info--" + _vm.color),
        ("v-info--" + _vm.position),
        {
            'v-info--square': _vm.square,
        } ]},[_vm._t("default"),_c('div',{staticClass:"v-info--text"},[_vm._v(" "+_vm._s(_vm.info)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }